@if (selectedChannel(); as channel) { @if (channel.messagesEndDate) {
<div class="old-messages-banner" (click)="loadLastMessages()">
  <div class="old-messages-banner__content">Click here to see messages from last visits.</div>
</div>
} }
